/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useEffect, useState } from "react";

import DataGridPica from "../../components/PantallesBKI/DataGridMui/DataGrid";
import { columnsControlTramits } from "../../components/PantallesBKI/DataGridMui/Columns/Columns";
import { CustomLoadingOverlay } from "../../components/PantallesBKI/DataGridMui/Loading/Loading";
import { URL_BKI } from "../../constants/URL";

import { TextField, Button, Grid } from "@mui/material";

/*ICONOS*/
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";

/*MENSAJES DE ALERTA*/
import ErrorAlert from "../../components/PantallesBKI/Alertas/ErrorAlert";
import AlertDelete from "../../components/PantallesBKI/Alertas/AlertDelete";
import InsertAlert from "../../components/PantallesBKI/Alertas/InsertAlert";

/* COMPONENTES MUI */
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

/*  COLORES */
import { colorVerdFosc, colorVermellFosc } from "../../constants/Colors";

import { getAuthToken } from "../../security/tokenUtils";

const APP_JSON = "application/json";
function TablaControlTramitsView() {
  const [token] = useState(getAuthToken());

  //Modal
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedRows, setSelectedRows] = useState([]);

  //Estado para escoger accion a realizar en la base de datos
  const [option, setOption] = React.useState([""]);

  const [selectionModel, setSelectionModel] = React.useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //Variables de edicion
  const [tramit, setTramit] = React.useState([]);
  const [modalitat, setModalitat] = React.useState([]);
  const [backoffice, setBackoffice] = React.useState([]);
  const [doctram, setDoctram] = React.useState([]);
  const [contextclass, setContextclass] = React.useState([]);
  const [tipusSeguretat, setTipusSeguretat] = React.useState([]);
  const [url, setUrl] = React.useState([]);
  const [aplicacio, setAplicacio] = React.useState([]);
  const [clientId, setClientId] = React.useState([]);
  const [tipusFile, setTipusFile] = React.useState([]);
  const [idOkRegistre, setIdOkRegistre] = React.useState([]);
  const [idOkNivell, setIdOkNivell] = React.useState([]);
  const [idKoRegistre, setIdKoRegistre] = React.useState([]);
  const [idKoNivell, setIdKoNivell] = React.useState([]);

  //Variables de edición Modal
  const [isEditing, setIsEditing] = useState(false);

  //Funciones para activar o desactivar la edición de los campos
  const handleStartEditing = () => {
    setIsEditing(true);
  };
  const handleStopEditing = () => {
    setIsEditing(false);
  };

  /*Control de cambios en los valores de los inputs*/
  const handleChangeTramit = (event) => {
    setTramit(event.target.value);
  };
  const handleChangeModalitat = (event) => {
    setModalitat(event.target.value);
  };
  const handleChangeBackoffice = (event) => {
    setBackoffice(event.target.value);
  };
  const handleChangeDoctram = (event) => {
    setDoctram(event.target.value);
  };
  const handleChangeContextclass = (event) => {
    setContextclass(event.target.value);
  };
  const handleChangeTipusSeguretat = (event) => {
    setTipusSeguretat(event.target.value);
  }
  const handleChangeUrl = (event) => {
    setUrl(event.target.value);
  }
  const handleChangeAplicacio = (event) => {
    setAplicacio(event.target.value);
  }
  const handleChangeClientId = (event) => {
    setClientId(event.target.value);
  }
   const handleChangeTipusFile = (event) => {
    setTipusFile(event.target.value);
  }
   const handleChangeIdOkRegistre = (event) => {
    setIdOkRegistre(event.target.value);
  }
   const handleChangeIdOkNivell = (event) => {
    setIdOkNivell(event.target.value);
  }
   const handleChangeIdKoRegistre = (event) => {
    setIdKoRegistre(event.target.value);
  }
   const handleChangeIdKoNivell = (event) => {
    setIdKoNivell(event.target.value);
  }
  //Estilos MODAL
  const styleModal = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    maxWidth: "800px",
    maxHeight: "80%",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
    p: 4,
  };

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props} className="customToolBar">
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <Button
          variant="contained"
          sx={colorVerdFosc}
          startIcon={<EditIcon />}
          size="small"
          onClick={() => accionRow("desar")}
          disabled={selectionModel.length === 0}
          style={{ marginLeft: 16 }}
        >
          Editar
        </Button>
        <Button
          variant="contained"
          type="submit"
          startIcon={<DeleteIcon />}
          onClick={() => AlertDelete(tramit, postData, "eliminar")}
          size="small"
          disabled={selectionModel.length === 0}
          sx={colorVermellFosc}
        >
          Eliminar
        </Button>
        <Button
          variant="contained"
          sx={colorVerdFosc}
          startIcon={<AddCircleIcon />}
          size="small"
          disabled={selectionModel.length === 1}
          onClick={() => accionRow("insertar")}
        >
          NOVA ENTRADA
        </Button>
      </GridToolbarContainer>
    );
  }

  const getData = () => {
    fetch(URL_BKI.CONTROL_TRAMITS, {
      headers: {
        "Content-Type": APP_JSON,
        Authorization: `Bearer ${token}`,
        Accept: APP_JSON,
      },
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        setData(myJson);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          `Ha ocurrido un error al pedir el recurso. Error: ${error.message}`
        );
        ErrorAlert("ERROR " + error);
        setIsLoading(false);
      });
  };

  const postData = async (accion) => {
    await fetch(URL_BKI.POST_CONTROL_TRAMITS, {
      method: "post",
      headers: {
        Accept: APP_JSON,
        "Content-Type": APP_JSON,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        TRAMIT: tramit,
        MODALITAT: modalitat,
        BACKOFFICE: backoffice,
        DOCTRAM: doctram,
        CONTEXTCLASS: contextclass,
        TIPUS_SEGURETAT: tipusSeguretat,
        URL: url,
        CLIENT_ID: clientId,
        TIPUS_FILE: tipusFile,
        APLICACIO: aplicacio,
        ACCION: accion,
        ID_OK_REGISTRE: idOkRegistre,
        ID_OK_NIVELL: idOkNivell,
        ID_KO_REGISTRE: idKoRegistre,
        ID_KO_NIVELL: idKoNivell,
      }),
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        if (myJson === 1) {
          switch (accion) {
            case "desar":
              InsertAlert("Dades actualitzades correctament");
              break;
            case "eliminar":
              InsertAlert("Dades eliminades correctament");
              break;
            case "insertar":
              InsertAlert("Dades agregades correctament");
              break;
            default:
              ErrorAlert("ERROR");
              break;
          }
          getData();
        } else {
          ErrorAlert("ERROR");
        }
      })
      .catch((error) => {
        ErrorAlert("Error " + error.message);
      });

    setOpen(false);
  };

  function accionRow(action) {
    if (action === "desar") {
      setOption("desar");
    } else if (action === "insertar") {
      //1r Limpiamos los campos
      setTramit("");
      setModalitat("");
      setBackoffice("");
      setDoctram("");
      setContextclass("");
      setTipusSeguretat("");
      setUrl("");
      setClientId("");
      setTipusFile("");
      setAplicacio("");
      setIdOkRegistre("");
      setIdOkNivell("");
      setIdKoRegistre("");
      setIdKoNivell("");
      //2n Pasamos la opcion que queremos hacer
      setOption("insertar");
    } else {
      throw new Error("Unexpected value for action");
    }

    handleOpen(); //abrimos modal
  }

  function mostraForm() {
    const row = selectedRows[0];

    if (selectionModel.length > 0) {
      setTramit(row.TRAMIT);
      setModalitat(row.MODALITAT);
      setBackoffice(row.BACKOFFICE);
      setDoctram(row.DOCTRAM);
      setContextclass(row.CONTEXTCLASS);
      setTipusSeguretat(row.TIPUS_SEGURETAT);
      setUrl(row.URL);
      setClientId(row.CLIENT_ID);
      setTipusFile(row.TIPUS_FILE)
      setAplicacio(row.APLICACIO);
      setIdOkRegistre(row.ID_OK_REGISTRE);
      setIdOkNivell(row.ID_OK_NIVELL);
      setIdKoRegistre(row.ID_KO_REGISTRE);
      setIdKoNivell(row.ID_KO_NIVELL);

      handleStopEditing();
    } else {
      handleStartEditing();
      setTramit("");
      setModalitat("");
      setBackoffice("");
      setDoctram("");
      setContextclass("");
      setTipusSeguretat("");
      setUrl("");
      setClientId("");
      setTipusFile("");
      setAplicacio("");
      setIdOkRegistre("");
      setIdOkNivell("");
      setIdKoRegistre("");
      setIdKoNivell("");
    }
  }

  useEffect(() => {
    mostraForm();
  }, [selectedRows]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="w-100, boxPantalla">
      <div>
        <Modal
          sx={{
            width: "60%",
            margin: "150px auto",
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModal} className="modal-edicio">
            <Grid container spacing={1}>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="tramit"
                  label="TRAMIT"
                  sx={{
                    width: "100%",
                  }}
                  value={tramit}
                  onChange={handleChangeTramit}
                  variant="outlined"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="modalitat"
                  label="MODALITAT"
                  sx={{
                    width: "100%",
                  }}
                  value={modalitat}
                  onChange={handleChangeModalitat}
                  variant="outlined"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="backoffice"
                  label="BACKOFFICE"
                  sx={{
                    width: "100%",
                  }}
                  value={backoffice}
                  onChange={handleChangeBackoffice}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="doctram"
                  label="DOCTRAM"
                  sx={{
                    width: "100%",
                  }}
                  value={doctram}
                  onChange={handleChangeDoctram}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  id="outlined-basic"
                  name="contextclass"
                  label="CONTEXTCLASS"
                  value={contextclass}
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeContextclass}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  id="outlined-basic"
                  name="url"
                  label="URL"
                  value={url}
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeUrl}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="tipusSeguretat"
                  label="TIPUS_SEGURETAT"
                  value={tipusSeguretat}
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeTipusSeguretat}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="clientId"
                  label="CLIENT_ID"
                  value={clientId}
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeClientId}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="aplicacio"
                  label="APLICACIO"
                  value={aplicacio}
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeAplicacio}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="tipusFile"
                  label="TIPUS_FILE"
                  value={tipusFile}
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeTipusFile}
                  variant="outlined"
                />
               </Grid>
               <Grid item xs={5}>
                   <TextField
                       id="outlined-basic"
                       name="idOkRegistre"
                       label="ID_OK_REGISTRE"
                       value={idOkRegistre}
                       sx={{
                           width: "100%",
                       }}
                       onChange={handleChangeIdOkRegistre}
                       variant="outlined"
                   />
               </Grid>

               <Grid item xs={5}>
                   <TextField
                       id="outlined-basic"
                       name="idOkNivell"
                       label="ID_OK_NIVELL"
                       value={idOkNivell}
                       sx={{
                           width: "100%",
                       }}
                       onChange={handleChangeIdOkNivell}
                       variant="outlined"
                   />
               </Grid>

               <Grid item xs={5}>
                   <TextField
                       id="outlined-basic"
                       name="idKoRegistre"
                       label="ID_KO_REGISTRE"
                       value={idKoRegistre}
                       sx={{
                           width: "100%",
                       }}
                       onChange={handleChangeIdKoRegistre}
                       variant="outlined"
                   />
               </Grid>

               <Grid item xs={5}>
                   <TextField
                       id="outlined-basic"
                       name="idKoNivell"
                       label="ID_KO_NIVELL"
                       value={idKoNivell}
                       sx={{
                           width: "100%",
                       }}
                       onChange={handleChangeIdKoNivell}
                       variant="outlined"
                   />
                </Grid>

            </Grid>
            <div className="btn-edicio">
              <Button
                variant="contained"
                type="submit"
                onClick={() => postData(option)}
                startIcon={<SaveIcon />}
                sx={colorVerdFosc}
              >
                Desar
              </Button>

              <Button
                variant="contained"
                startIcon={<CancelIcon />}
                onClick={handleClose}
                color="inherit"
              >
                Cancelar
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
      <h2>Taula control de tramits</h2>
      <DataGridPica
        ampleTaula="90%"
        checkboxSelection={true}
        data={data}
        density="compact"
        rowHeight={90}
        col={columnsControlTramits}
        getRowId={(row) => `${row.TRAMIT}_${row.MODALITAT}`}
        components={{
          Toolbar: CustomToolbar,
          LoadingOverlay: CustomLoadingOverlay,
        }}
        selectionModel={selectionModel}
        onSelectionModelChange={(selection) => {
          const selectedIDs = [...new Set(selection)]; //Obtengo el campo CLAU y GRUP seleccionado

          if (selection.length > 1) {
            //Comparo si he seleccionado otro valor anteriormente para hacer el cambio

            const selectionSet = new Set(selectionModel); //obtenemos el valor anterior
            const result = selection.filter((s) => !selectionSet.has(s)); //comprobamos si es diferente el valor seleccionado al anterior, y si es así lo cambiamos
            setSelectionModel(result);
            setSelectedRows(
              data.filter((row) =>
                result.includes(`${row.TRAMIT}_${row.MODALITAT}`)
              )
            ); //Filtramos a partir del nuevo campo seleccionado al origen de datos
          } else {
            const getSelectedRows = data.filter((row) =>
              selectedIDs.includes(`${row.TRAMIT}_${row.MODALITAT}`)
            ); //Busco en el origen de datos a partir del valor seleccionado

            setSelectedRows(getSelectedRows); //Asigno los valores obtenidos
            setSelectionModel(selection); //Guardo la CLAU actual seleccionada
          }
        }}
        loading={isLoading}
      />
    </div>
  );
}
export default TablaControlTramitsView;
